module.exports = __webpack_public_path__ + "img/2.77dc1891.png";